import * as Yup from 'yup';
import { emailRegEx, phoneRegEx } from '@/utils/RegularExpressions';

const defaultStepsSchema = Yup.object({
  applicantInformation: Yup.object({
    fullName: Yup.string().required('Required').max(250, 'Must be less than 250 characters.'),
    contactEmail: Yup.string().required('Required').matches(emailRegEx, 'Please enter a valid email address'),
  }),
});

const part1Schema = Yup.object({
  step1: Yup.object({
    name: Yup.string().required('Required'),
    submitter: Yup.string().required('Required'),
    submitterTitle: Yup.string().required('Required'),
    streetAddress: Yup.string().required('Required'),
    phone: Yup.string().required('Required').matches(phoneRegEx, 'Please enter a valid phone number'),
    fax: Yup.string().matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid fax number',
    }),
    email: Yup.string().required('Required').matches(emailRegEx, 'Please enter a valid email address'),
  }),
});

const part2Schema = Yup.object({
  step2: Yup.object({
    f1: Yup.object({
      selectedFiles: Yup.mixed(),
    }),
    f2: Yup.object({
      selectedFiles: Yup.mixed(),
    }),
    f3: Yup.object({
      selectedFiles: Yup.mixed(),
    }),
    f4: Yup.object({
      selectedFiles: Yup.mixed(),
    }),
    f5: Yup.object({
      selectedFiles: Yup.mixed(),
    }),
  }),
});

const part3Schema = Yup.object({
  step3: Yup.object({
    section1: Yup.object({
      doesDocumentDefines: Yup.string(),
      articlesOfIncorporation: Yup.object().when('doesDocumentDefines', ([doesDocumentDefines], schema) => {
        return doesDocumentDefines === 'articlesOfIncorporation'
          ? schema.shape({
              section: Yup.string().required('Required'),
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      byLaws: Yup.object().when('doesDocumentDefines', ([doesDocumentDefines], schema) => {
        return doesDocumentDefines === 'byLaws'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      charter: Yup.object().when('doesDocumentDefines', ([doesDocumentDefines], schema) => {
        return doesDocumentDefines === 'charter'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
    }),
  }),
});

const part4Schema = Yup.object({
  step4: Yup.object({
    section1: Yup.object({
      q1: Yup.string(),
      articlesOfIncorporation: Yup.object().when('q1', ([q1], schema) => {
        return q1 === 'articlesOfIncorporation'
          ? schema.shape({
              section: Yup.string().required('Required'),
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      byLaws: Yup.object().when('q1', ([q1], schema) => {
        return q1 === 'byLaws'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      charter: Yup.object().when('q1', ([q1], schema) => {
        return q1 === 'charter'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
    }),
    providedEvidence: Yup.string(),
    section2: Yup.object({
      isChartered: Yup.string(),
      q2: Yup.string(),
      articlesOfIncorporation: Yup.object().when('q2', ([q2], schema) => {
        return q2 === 'articlesOfIncorporation'
          ? schema.shape({
              section: Yup.string().required('Required'),
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      byLaws: Yup.object().when('q2', ([q2], schema) => {
        return q2 === 'byLaws'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      charter: Yup.object().when('q2', ([q2], schema) => {
        return q2 === 'charter'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
    }),
    section3: Yup.object({
      isSponsored: Yup.string(),
      q3: Yup.string(),
      articlesOfIncorporation: Yup.object().when('q3', ([q3], schema) => {
        return q3 === 'articlesOfIncorporation'
          ? schema.shape({
              section: Yup.string().required('Required'),
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      byLaws: Yup.object().when('q3', ([q3], schema) => {
        return q3 === 'byLaws'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
      charter: Yup.object().when('q3', ([q3], schema) => {
        return q3 === 'charter'
          ? schema.shape({
              page: Yup.string().required('Required'),
              paragraph: Yup.string().required('Required'),
            })
          : schema;
      }),
    }),
  }),
});

const part5Schema = Yup.object({
  step5: Yup.object({
    fiscalYear: Yup.string().required('Required'),
    hasCompliance: Yup.string().optional(),
  }),
});

export const validationSchema = [defaultStepsSchema, part1Schema, part2Schema, part3Schema, part4Schema, part5Schema];
